import { PageQuickAccessBar } from '@/components/common/Providers/GraphqlProvider/generated';

import { BlockColor } from '../admin/components/GeneralInformationQuickAccessBar';

// Función auxiliar para dividir array en chunks
export const chunkArray = <T>(arr: T[], size: number): T[][] => {
  return arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, [] as T[][]);
};

export const getWrapperBackgroundColor = (color?: string | null) => {
  switch (color) {
    case BlockColor.WHITE:
      return 'bg-white';
    case BlockColor.GRAY:
      return 'bg-hawkesBlue ';
    case BlockColor.SYSTEM:
    default:
      return 'bg-primary';
  }
};

export type QuickAccessSharedProps = {
  quickAccessBar?: PageQuickAccessBar | undefined;
  isCarousel?: boolean | null;
  itemsPerView: number;
  isLightBackground?: boolean | undefined;
  sortedItems?: PageQuickAccessBar['items'];
};
